// =============================================================================
// ProgressionNavigation.js — la barre de 2 px qui dit « la page arrive »
// (refonte « Mosaïque vivante », lot L6 ; synthèse §6.5 et règle couleur v2,
// point 8 : « barre de progression de navigation à la teinte du module »).
//
// Quand navTo attend le code d'une vue (src/prechargementVues.js), la vue
// courante RESTE à l'écran et cette barre avance sous l'en-tête, à la teinte du
// module visé ; elle n'apparaît qu'après 100 ms (un morceau déjà en cache ne la
// fait jamais voir), se complète puis s'efface à l'arrivée. Toujours montée
// (les transitions CSS jouent à l'entrée comme à la sortie) ; aucune boucle.
// Styles : .cq-progression (src/coquilleStyles.js).
// =============================================================================
import React, { useEffect, useRef, useState } from "react";

export default function ProgressionNavigation({ actif, couleur }) {
  const [etat, setEtat] = useState(actif ? "charge" : "repos");
  const precedent = useRef(actif);
  useEffect(() => {
    if (actif === precedent.current) return undefined;
    precedent.current = actif;
    if (actif) { setEtat("charge"); return undefined; }
    setEtat("termine");
    const t = setTimeout(() => setEtat("repos"), 400);
    return () => clearTimeout(t);
  }, [actif]);
  return (
    <div className="cq-progression" data-etat={etat} role="progressbar"
      aria-label="Chargement de la page" aria-hidden={etat !== "charge"}
      aria-busy={etat === "charge"} style={couleur ? { "--cq-h": couleur } : undefined} />
  );
}
